export const TRIGGER_CHANNEL_TRACKING = 'TRIGGER_CHANNEL_TRACKING';
export const triggerChannelTracking = data => ({
  type: TRIGGER_CHANNEL_TRACKING,
  value: {data},
});
